import { useSelector } from 'react-redux';
import get from 'lodash/get';

export const useIndexData = () => {
  const timerRunning = useSelector(
    ({ timer }) => get(timer, 'timerRunning.data') || {}
  );
  const timerRunningLoading = useSelector(({ timer }) =>
    get(timer, 'timerRunning.loading', false)
  );
  const isStarting = useSelector(({ timer }) =>
    get(timer, 'isStarting', false)
  );
  const isConfirmModal = useSelector(({ timer }) =>
    get(timer, 'confirmClockModal.isOpen', false)
  );
  const isClockModal = useSelector(({ timer }) =>
    get(timer, 'clockModal.isOpen', false)
  );
  const timerExistingShift = useSelector(
    ({ timer }) => get(timer, 'existingShift') || {}
  );
  const clockObj = useSelector(
    ({ timer }) => get(timer, 'clockModal.data') || {}
  );
  const submittingNA = useSelector(({ userSettings }) =>
    get(userSettings, 'settings.submittingNA')
  );
  const isNightAssistStarting = useSelector(({ nightAssist }) =>
    get(nightAssist, 'isStarting', false)
  );

  return {
    timerRunning,
    timerRunningLoading,
    isStarting,
    isConfirmModal,
    isClockModal,
    timerExistingShift,
    clockObj,
    submittingNA,
    isNightAssistStarting,
  };
};
